import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const SpotDetailsFacility = loadable(() => import('./SpotDetailsFacility'));

SpotDetailsFacility.getInitialState = getInitialState;

export default SpotDetailsFacility;
